import { render, staticRenderFns } from "./RemoteScrapList.vue?vue&type=template&id=96ca82da&scoped=true&"
import script from "./RemoteScrapList.vue?vue&type=script&lang=js&"
export * from "./RemoteScrapList.vue?vue&type=script&lang=js&"
import style0 from "./RemoteScrapList.vue?vue&type=style&index=0&id=96ca82da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ca82da",
  null
  
)

export default component.exports